(function () {
    var HH_CARTO = window.HH_CARTO = window.HH_CARTO || {};

    function hhDistanceKm(lat1, lon1, lat2, lon2) {
        var R = 6371;
        var dLat = (lat2 - lat1) * Math.PI / 180;
        var dLon = (lon2 - lon1) * Math.PI / 180;
        var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
            Math.sin(dLon / 2) * Math.sin(dLon / 2);
        return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    }

    function hhFormatDistance(km) {
        if (km < 1) return Math.round(km * 1000) + ' m';
        if (km < 10) return (Math.round(km * 10) / 10).toString().replace('.', ',') + ' km';
        return Math.round(km) + ' km';
    }

    function hhSetViewLowered(map, latlng, zoom) {
        var size = map.getSize();
        var point = map.project(latlng, zoom);
        var centerPoint = point.subtract([0, size.y * 0.25]);
        map.setView(map.unproject(centerPoint, zoom), zoom);
    }

    // ----------------------------------------------------------------------
    // PAGINATION DE LA LISTE DES MAGASINS (12 par page, numéros en fin de liste)
    // ----------------------------------------------------------------------
    var HH_PAGE_SIZE = 9;

    function hhPageItems(current, totalPages) {
        var delta = 1;
        var range = [];
        var result = [];
        var last;
        for (var i = 1; i <= totalPages; i++) {
            if (i === 1 || i === totalPages || (i >= current - delta && i <= current + delta)) {
                range.push(i);
            }
        }
        for (var j = 0; j < range.length; j++) {
            var n = range[j];
            if (last) {
                if (n - last === 2) {
                    result.push(last + 1);
                } else if (n - last > 2) {
                    result.push('…');
                }
            }
            result.push(n);
            last = n;
        }
        return result;
    }

    function hhRenderPaginationNav($nav, current, totalPages) {
        if (totalPages <= 1) {
            $nav.empty().attr('hidden', true);
            return;
        }
        $nav.removeAttr('hidden');
        var html = '';
        html += '<button type="button" class="carto-pagination__btn carto-pagination__prev" data-page="' + (current - 1) + '"' + (current === 1 ? ' disabled' : '') + ' aria-label="Page précédente">‹</button>';
        hhPageItems(current, totalPages).forEach(function (it) {
            if (it === '…') {
                html += '<span class="carto-pagination__dots">…</span>';
            } else {
                html += '<button type="button" class="carto-pagination__btn carto-pagination__num' + (it === current ? ' is-active' : '') + '" data-page="' + it + '"' + (it === current ? ' aria-current="page"' : '') + '>' + it + '</button>';
            }
        });
        html += '<button type="button" class="carto-pagination__btn carto-pagination__next" data-page="' + (current + 1) + '"' + (current === totalPages ? ' disabled' : '') + ' aria-label="Page suivante">›</button>';
        $nav.html(html);
    }

    function hhApplyPagination(blocId, page) {
        var $ = jQuery;
        var $liste = $('.liste_tiles[data-bloc="' + blocId + '"]');
        if (!$liste.length) return;
        var $nav = $liste.next('.carto-pagination');
        if (!$nav.length) {
            $nav = $('<nav class="carto-pagination" data-bloc="' + blocId + '" aria-label="Pagination des magasins"></nav>');
            $liste.after($nav);
        }
        var $tiles = $liste.children('.tile_carto');
        var total = $tiles.length;
        var totalPages = Math.max(1, Math.ceil(total / HH_PAGE_SIZE));
        page = Math.min(Math.max(1, page || 1), totalPages);
        var start = (page - 1) * HH_PAGE_SIZE;
        var end = start + HH_PAGE_SIZE;
        $tiles.each(function (i) {
            if (i >= start && i < end) {
                this.classList.remove('is-paged-out');
            } else {
                this.classList.add('is-paged-out');
            }
        });
        hhRenderPaginationNav($nav, page, totalPages);
        $liste.data('currentPage', page);
    }

    jQuery(document).on('click', '.carto-pagination__btn', function () {
        var $ = jQuery;
        var $btn = $(this);
        if ($btn.is('[disabled]')) return;
        var $nav = $btn.closest('.carto-pagination');
        var blocId = String($nav.data('bloc'));
        var page = parseInt($btn.attr('data-page'), 10);
        if (isNaN(page)) return;
        hhApplyPagination(blocId, page);
        var $liste = $('.liste_tiles[data-bloc="' + blocId + '"]');
        if ($liste.length) {
            $('html, body').animate({scrollTop: $liste.offset().top - 100}, 250);
        }
    });

    // ----------------------------------------------------------------------
    // INITIALISATION DE LA CARTE + MARKERS
    // ----------------------------------------------------------------------
    jQuery(document).ready(function ($) {
        $('.carte').each(function () {
            var $carte = $(this);
            var mapId = $carte.attr('id');
            var blocId = mapId.replace('hh_dynamic_map_', '');

            var default_lat = 46.603354;
            var default_lon = 1.888334;
            var default_zoom = 6;

            var map = L.map(mapId, {zoomControl: false}).setView([default_lat, default_lon], default_zoom);

            L.control.zoom({
                zoomInTitle: 'Zoomer',
                zoomOutTitle: 'Dézoomer'
            }).addTo(map);

            L.tileLayer('https://services.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Base/MapServer/tile/{z}/{y}/{x}', {
                maxZoom: 16,
                attribution: '© Esri'
            }).addTo(map);

            L.tileLayer('https://services.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Reference/MapServer/tile/{z}/{y}/{x}', {
                maxZoom: 16,
                pane: 'shadowPane'
            }).addTo(map);

            map.on('movestart', function () {
                map.closePopup();
            });

            map.scrollWheelZoom.disable();
            map.boxZoom.disable();
            map.keyboard.disable();
            map.dragging.enable();
            map.touchZoom.enable();
            map.doubleClickZoom.enable();

            var $hint = $('<div class="map-scroll-hint">Utilisez <kbd>Ctrl</kbd> + scroll pour zoomer</div>');
            $carte.parent().css('position', 'relative').append($hint);
            var hintTimeout;
            map.getContainer().addEventListener('wheel', function (e) {
                if (e.ctrlKey) {
                    e.preventDefault();
                    if (e.deltaY < 0) {
                        map.zoomIn();
                    } else {
                        map.zoomOut();
                    }
                } else {
                    $hint.addClass('visible');
                    clearTimeout(hintTimeout);
                    hintTimeout = setTimeout(function () {
                        $hint.removeClass('visible');
                    }, 1500);
                }
            }, {passive: false});

            var markersById = {};
            var markersData = [];
            var markerClusters = L.markerClusterGroup({
                iconCreateFunction: function (cluster) {
                    return L.divIcon({
                        html: '<div class="cluster-icon"><img src="/wp-content/themes/hh/src/img/mapmarker.svg" /><span>' + cluster.getChildCount() + '</span></div>',
                        className: 'custom-cluster',
                        iconSize: [40, 40]
                    });
                }
            });

            var SVGiconDefault = L.icon({
                iconUrl: '/wp-content/themes/hh/src/img/mapmarker.svg',
                iconSize: [32, 43],
                iconAnchor: [16, 43]
            });

            $carte.find('> .marker').each(function () {
                var $markerEl = $(this);
                var id = $markerEl.data('id');
                var lat = parseFloat($markerEl.data('lat'));
                var lng = parseFloat($markerEl.data('lng'));
                var title = $markerEl.data('title') || '';
                var cd = $markerEl.data('cd') || '';
                var texte = $markerEl.data('texte') || '';
                var single = $markerEl.data('single');
                var link = $markerEl.data('link') || '#';
                var logo = $markerEl.data('logo') || '';
                var logoAlt = $markerEl.data('logo-alt') || '';

                if (lat && lng) {
                    var marker = L.marker([lat, lng], {icon: SVGiconDefault});
                    var buttonHTML = '';
                    if (single == 1 || single === true || single === "1" || single === "true") {
                        buttonHTML = '<a href="' + link + '" class="map-popup__btn bouton" target="_blank" rel="noopener noreferrer">' + (texte || 'En savoir +') + '</a>';
                    }
                    var popupHTML = '<div class="map-popup">' +
                        (logo ? '<img src="' + logo + '" alt="' + logoAlt + '" class="map-popup__logo">' : '') +
                        (title ? '<h3>' + title + '</h3>' : '') +
                        (cd ? '<span class="cd">' + cd + '</span>' : '') +
                        buttonHTML +
                        '</div>';

                    marker.bindPopup(popupHTML, {autoPan: false});
                    marker.off('click');

                    marker.on('click', function (e) {
                        var targetLatLng = e.latlng;

                        if (map.getCenter().equals(targetLatLng)) {
                            marker.openPopup();
                        } else {
                            map.once('moveend', function () {
                                marker.openPopup();
                            });
                            hhSetViewLowered(map, targetLatLng, map.getZoom());
                        }
                    });

                    markerClusters.addLayer(marker);
                    if (id !== undefined && id !== null && id !== '') {
                        markersById[id] = marker;
                    }
                    markersData.push({id: id, lat: lat, lng: lng, marker: marker});
                }

                $markerEl.remove();
            });
            map.addLayer(markerClusters);

            setTimeout(function () {
                map.invalidateSize();
            }, 300);

            map.setView([default_lat, default_lon], default_zoom);

            HH_CARTO[blocId] = {
                map: map,
                clusters: markerClusters,
                markersById: markersById,
                markersData: markersData,
                defaultView: {lat: default_lat, lon: default_lon, zoom: default_zoom},
                searchPin: null
            };
        });
    });

    // ----------------------------------------------------------------------
    // RECHERCHE PAR PROXIMITÉ (ville ou code postal)
    // ----------------------------------------------------------------------
    jQuery(document).ready(function ($) {
        $('.carto-search').each(function () {
            var $wrap = $(this);
            var blocId = String($wrap.data('bloc'));
            var $form = $wrap.find('.carto-search__form');
            var $input = $wrap.find('.carto-search__input');
            var $reset = $wrap.find('.carto-search__reset');
            var $msg = $wrap.find('.carto-search__feedback');
            var $liste = $('.liste_tiles[data-bloc="' + blocId + '"]');
            var fullHtml = $liste.length ? $liste.html() : null;

            function setMsg(text, isError) {
                $msg.text(text || '').toggleClass('is-error', !!isError);
            }

            function resetMapView() {
                var ctx = window.HH_CARTO && window.HH_CARTO[blocId];
                if (!ctx) return;
                if (ctx.searchPin) {
                    ctx.map.removeLayer(ctx.searchPin);
                    ctx.searchPin = null;
                }
                ctx.map.setView([ctx.defaultView.lat, ctx.defaultView.lon], ctx.defaultView.zoom);
            }

            function doReset() {
                if ($liste.length) {
                    $liste.html(fullHtml);
                }
                $input.val('');
                setMsg('');
                $reset.attr('hidden', true);
                resetMapView();
                if ($liste.length) {
                    hhApplyPagination(blocId, 1);
                }
            }

            // Trouve le marker le plus proche directement sur la carte (toujours disponible)
            function findNearestMarker(lat, lon) {
                var ctx = window.HH_CARTO && window.HH_CARTO[blocId];
                if (!ctx || !ctx.markersData || !ctx.markersData.length) return null;
                var nearestId = null;
                var nearestDist = Infinity;
                ctx.markersData.forEach(function (m) {
                    var d = hhDistanceKm(lat, lon, m.lat, m.lng);
                    if (d < nearestDist) {
                        nearestDist = d;
                        nearestId = m.id;
                    }
                });
                return nearestId;
            }

            // Trie les tuiles (si présentes) et renvoie l'id de la plus proche
            function sortTilesByProximity(lat, lon) {
                if (!$liste.length) return null;
                $liste.html(fullHtml);
                var tiles = $liste.children('.tile_carto').get();
                tiles.forEach(function (el) {
                    var $t = $(el);
                    var tLat = parseFloat($t.attr('data-lat'));
                    var tLng = parseFloat($t.attr('data-lng'));
                    var d = (isFinite(tLat) && isFinite(tLng)) ? hhDistanceKm(lat, lon, tLat, tLng) : Infinity;
                    $t.data('distance', d);
                    var $dist = $t.find('.tile_carto__distance');
                    if (isFinite(d)) {
                        $dist.text('À ' + hhFormatDistance(d)).removeAttr('hidden');
                    } else {
                        $dist.attr('hidden', true).text('');
                    }
                });
                tiles.sort(function (a, b) {
                    return $(a).data('distance') - $(b).data('distance');
                });
                $liste.append(tiles);
                $liste.find('.tile_carto').removeClass('is-nearest');
                var $nearest = $(tiles[0]);
                $nearest.addClass('is-nearest');
                hhApplyPagination(blocId, 1);
                return $nearest.length ? $nearest.attr('data-id') : null;
            }

            function focusMap(lat, lon, nearestId) {
                var ctx = window.HH_CARTO && window.HH_CARTO[blocId];
                if (!ctx) return;
                if (ctx.searchPin) {
                    ctx.map.removeLayer(ctx.searchPin);
                    ctx.searchPin = null;
                }
                ctx.searchPin = L.circleMarker([lat, lon], {
                    radius: 9, color: '#ffffff', weight: 2, fillColor: '#E30613', fillOpacity: 1
                }).addTo(ctx.map);

                var marker = (nearestId != null) ? ctx.markersById[nearestId] : null;

                if (marker && ctx.clusters && ctx.clusters.zoomToShowLayer) {
                    ctx.clusters.zoomToShowLayer(marker, function () {
                        ctx.map.once('moveend', function () {
                            marker.openPopup();
                        });
                        hhSetViewLowered(ctx.map, marker.getLatLng(), Math.max(ctx.map.getZoom(), 12));
                    });
                } else if (marker) {
                    ctx.map.once('moveend', function () {
                        marker.openPopup();
                    });
                    hhSetViewLowered(ctx.map, marker.getLatLng(), 12);
                } else {
                    ctx.map.setView([lat, lon], 9);
                }
            }
            $form.on('submit', function (e) {
                e.preventDefault();
                var q = ($input.val() || '').trim();
                if (!q) {
                    setMsg('Saisissez une ville ou un code postal.', true);
                    return;
                }

                var GENERIC_CP = {'69000': 'Lyon', '75000': 'Paris', '13000': 'Marseille'};
                if (GENERIC_CP[q]) {
                    q = GENERIC_CP[q];
                }

                setMsg('Recherche en cours…', false);
                if ($liste.length) {
                    $liste.css('opacity', '0.4');
                }

                fetch('https://api-adresse.data.gouv.fr/search/?limit=1&q=' + encodeURIComponent(q))
                    .then(function (r) {
                        return r.json();
                    })
                    .then(function (data) {
                        if ($liste.length) {
                            $liste.css('opacity', '1');
                        }
                        if (!data || !data.features || !data.features.length) {
                            setMsg('Aucun lieu trouvé pour « ' + q + ' ».', true);
                            return;
                        }
                        var feat = data.features[0];
                        var coords = feat.geometry.coordinates;
                        var lon = coords[0], lat = coords[1];
                        var props = feat.properties || {};
                        var ville = props.city || props.name || q;
                        var cp = props.postcode || '';
                        var lieu = cp ? (ville + ' (' + cp + ')') : ville;

                        // Toujours calculé à partir des markers de la carte
                        var nearestId = findNearestMarker(lat, lon);
                        // Si des tuiles existent, on les trie et on privilégie leur "plus proche"
                        var nearestTileId = sortTilesByProximity(lat, lon);
                        if (nearestTileId !== null) {
                            nearestId = nearestTileId;
                        }

                        focusMap(lat, lon, nearestId);
                        setMsg('Résultat le plus proche de ' + lieu, false);
                        $reset.removeAttr('hidden');
                    })
                    .catch(function () {
                        if ($liste.length) {
                            $liste.css('opacity', '1');
                        }
                        setMsg('Erreur lors de la recherche. Réessayez.', true);
                    });
            });

            $reset.on('click', function () {
                doReset();
            });
        });
    });

    // ----------------------------------------------------------------------
    // INITIALISATION DE LA PAGINATION (au chargement)
    // ----------------------------------------------------------------------
    jQuery(document).ready(function ($) {
        $('.liste_tiles').each(function () {
            hhApplyPagination(String($(this).data('bloc')), 1);
        });
    });
})();